import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import CandidateCard from 'components/CandidateCard';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import { VisaStatus } from 'API';
import ProcessType from '../inputSections/ProcessType';
import ButtonNav from './ButtonNav';
import Panel from './Panel';

const CreateProcessModalPanelStart: React.FC = () => {
  const { process } = useContext(CreateProcessContext);
  const canGoToNext = process.requestedProcess !== undefined;

  return (
    <Panel>
      <CandidateCard />

      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" paragraph>
          CHOOSE ONE. If unsure, select “Not Sure.”
        </Typography>
      </Box>

      <ProcessType
        hideHeader
        processOptions={[
          VisaStatus.H_1B,
          VisaStatus.PERM_GREEN_CARD,
          VisaStatus.NOT_SURE,
          // VisaStatus.H_1B_LOTTERY,
          // VisaStatus.H_1B_24_LOTTERY,
          // VisaStatus.H_1B_25_LOTTERY,
          VisaStatus.H_1B_26_LOTTERY,
          VisaStatus.E_3,
          VisaStatus.E_3_CONSULATE,
          VisaStatus.H_1B1,
          VisaStatus.H_1B1_CONSULATE,
          VisaStatus.TN,
          VisaStatus.TN_MEXICO,
          VisaStatus.TN_CANADA,
          VisaStatus.USCIS_PRIMARY,
          VisaStatus.USCIS_PRIMARY_2,
          VisaStatus.AOS,
          VisaStatus.EAD_PRIMARY,
          VisaStatus.GLOBAL_PROCESS,
        ]}
      />

      <ButtonNav disabled={!canGoToNext} />
    </Panel>
  );
};

export default CreateProcessModalPanelStart;
